import React, { useCallback, useState } from "react";
import { observer } from "mobx-react";
import { ItemsContainer } from "./Items.styled";
import SMSItem from "../../../../components/itemList/SMSItemList";
import SMSSlideOut from "../../../../components/PreviewSlideOut/SMSSlideOut";

const Items = observer(({ items = [] }) => {
  const [showSMSSlideOut, setShowSMSSlideOut] = useState(false);
  const [selectedSMS, setSelectedSMS] = useState(null);

  const handleOpenSlideOut = useCallback((sms) => {
    setSelectedSMS(sms);
    setShowSMSSlideOut(true);
  }, []);

  const handleCloseSlideOut = useCallback(() => {
    setShowSMSSlideOut(false);
    setSelectedSMS(null);
  }, []);

  if (!items.length) {
    return (
      <ItemsContainer>
        <p>No SMS activities to show.</p>
      </ItemsContainer>
    );
  }

  return (
    <>
      <ItemsContainer>
        {items.map((sms) => (
          <SMSItem key={sms.id} info={sms} onOpen={handleOpenSlideOut} />
        ))}
      </ItemsContainer>
      <SMSSlideOut
        open={showSMSSlideOut}
        onClose={handleCloseSlideOut}
        sms={selectedSMS}
      />
    </>
  );
});

export default Items;
